import {
    Box, Button,
    Typography,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    FormHelperText, Switch,
    Link
} from '@mui/material';
import { LANG } from '../../language/lang';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect } from 'react';
import { useInput } from '../../utils/hooks';
import { clearErrors, handleRegistration } from '../../store/slice/userSlice'
import { Link as RouterLink } from 'react-router-dom'

const RegistrationBox = ({ isMobile, toggleAuthMode, onSuccess }) => {

    const dispatch = useDispatch()
    const { errors, globalError, isLoading } = useSelector(state => state.user)
    const login = useInput('', { isEmpty: true })
    const password = useInput('', { isEmpty: true, minLength: 8 })
    const [confirmRule, setConfirmRule] = useState(false)
    const email = useInput('', { isEmpty: true, isEmail: true })
    const [showPassword, setShowPassword] = useState(false)
    const isFormValid = login.inputValid && email.inputValid && password.inputValid && confirmRule
    const [isSubmitted, setIsSubmitted] = useState(false)

    useEffect(() => {
        if (isSubmitted && !isLoading && Object.keys(errors).length === 0 && !globalError) {
            setIsSubmitted(false)
            onSuccess()
        }
    }, [isSubmitted, isLoading, errors, globalError, onSuccess])

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = () => {
        if (!isFormValid || isLoading) {
            return
        }
        setIsSubmitted(true)
        dispatch(handleRegistration(
            {
                login: login.value,
                password: password.value,
                email: email.value,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                rules: confirmRule ? 1 : 0
            }))
    }

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width='100%'
                gap={2}
            >
                <Typography variant={isMobile ? 'h6' : 'h5'} fontWeight={600} textAlign="center">
                    {LANG("REGISTRATION_TITLE")}
                </Typography>
                {globalError && <Typography sx={{ textAlign: 'center', width: '100%', display: 'block' }} variant="caption" color={"red"}>{globalError.message}</Typography>}

                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-login">{LANG('TEXT_LABEL_LOGIN')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-login"
                        label={LANG('TEXT_LABEL_LOGIN')}
                        onChange={e => {
                            if (errors?.login) {
                                dispatch(clearErrors())
                            }
                            login.onChange(e)
                        }}
                        onBlur={e => login.onBlur(e)}
                        value={login.value}
                        error={!!errors?.login || !!login.getError()}
                    />
                    {login.getError() && <FormHelperText sx={{ maxWidth: '300px' }} error>{login.getError()}</FormHelperText>}
                    {errors?.login && <FormHelperText sx={{ maxWidth: '300px' }} error>{errors?.login.message}</FormHelperText>}
                </FormControl>

                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-email">{LANG('TEXT_LABEL_EMAIL')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-email"
                        label={LANG('TEXT_LABEL_EMAIL')}
                        onChange={e => {
                            if (errors?.email) {
                                dispatch(clearErrors())
                            }
                            email.onChange(e)
                        }}
                        onBlur={e => email.onBlur(e)}
                        value={email.value}
                        error={!!errors?.email || !!email.getError()}
                    />
                    {email.getError() && <FormHelperText sx={{ maxWidth: '300px' }} error>{email.getError()}</FormHelperText>}
                    {errors?.email && <FormHelperText sx={{ maxWidth: '300px' }} error>{errors?.email.message}</FormHelperText>}
                </FormControl>

                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">{LANG('TEXT_LABEL_PASSWORD')}</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        label={LANG('TEXT_LABEL_PASSWORD')}
                        value={password.value}
                        error={!!password.getError() || (password.isDirty && password.minLength && password.value.length > 0)}
                        onBlur={e => password.onBlur(e)}
                        onChange={
                            (e) => password.onChange(e)
                        }
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={
                                        showPassword ? 'hide the password' : 'display the password'
                                    }
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    onMouseUp={handleMouseUpPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }

                    />
                    {password.getError() && <FormHelperText sx={{ maxWidth: '300px' }} error>{password.getError()}</FormHelperText>}
                    {errors?.password && <FormHelperText sx={{ maxWidth: '300px' }} error>{errors?.password.message}</FormHelperText>}

                </FormControl>


                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Switch
                        checked={confirmRule}
                        onChange={(e) => setConfirmRule(e.target.checked)}
                    />
                    <Box>
                        {LANG('TEXT_REG_FORM_ACCEPT_RULES')} <Link component={RouterLink} to="/rules"> {LANG('TEXT_REG_FORM_RULES')}</Link>

                    </Box>
                </Box>

                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                >
                    <Button variant="contained" fullWidth onClick={handleSubmit} disabled={!isFormValid || isLoading}>{LANG('BTN_REGISTER')}</Button>

                    <Button variant="text" onClick={toggleAuthMode}>
                        {LANG('TEXT_LABEL_HAVE_ACCOUNT')} {LANG('BTN_LOGIN')}
                    </Button>
                </Box>


            </Box>
        </>
    );
};

export default RegistrationBox;